<div *ngIf="projectId" dropdown  dropdownToggle class="dropdown dropdown-language align-items-center btn btn-clean btn-icon btn-lg d-flex px-2 w-auto" aria-haspopup="true" [dropup]="isDropup">
    <div class="project-name-section">
        <span class="project-label">{{l("CurrentProject")}}:</span>
        <span>{{projectName}}</span>
    </div>
    <div  
        class="topbar-item" 
        data-toggle="dropdown" 
        data-offset="10px,0px" aria-expanded="false">
        <div [class]="customStyle">
            <i class="fas fa-chevron-down"></i>
        </div>
    </div>
    <div *dropdownMenu class="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-sm"
        [attr.aria-label]="l('Languages')">
        <ul class="navi navi-hover py-4">
            <li class="navi-item" *ngFor="let project of projects">
                <a class="navi-link" (click)="changeProject(project)">
                    <span class="navi-text">
                        {{project.name}}
                    </span>
                    <i *ngIf="project.id===projectId" class="fa fa-check active-project" aria-hidden="true"></i>
                </a>
            </li>
        </ul>
    </div>
</div>